import React, { createContext, useReducer } from "react";

export const BookContext = createContext();

const initialState = {
  bookCategories: null,
  error: false,
  loading: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "GET_CATEGORIES":
      return {
        ...state,
        bookCategories: action.payload,
        error: false,
        loading: false,
      };
    case "ERROR":
      return {
        ...state,
        error: true,
        loading: false,
      };
    default:
      throw new Error();
  }
};

export const BookContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <BookContext.Provider value={[state, dispatch]}>
      {props.children}
    </BookContext.Provider>
  );
};
